import { toast, ToastContent, ToastOptions, TypeOptions } from 'react-toastify';
import { ReactComponent as InfoIcon } from '@/assets/icons/toast/info.svg';
import { ReactComponent as WarningIcon } from '@/assets/icons/toast/warning.svg';
import { ReactComponent as SuccessIcon } from '@/assets/icons/toast/success.svg';
import { ReactComponent as ErrorIcon } from '@/assets/icons/toast/error.svg';
import { TOAST_AUTO_CLOSE_MS } from '@/constants/ui/toast';

export const useToast = () => {
  const getToastIcon = (type: TypeOptions | undefined) => {
    switch (type) {
      case 'info':
        return <InfoIcon />;
      case 'warning':
        return <WarningIcon />;
      case 'success':
        return <SuccessIcon />;
      case 'error':
        return <ErrorIcon />;
    }
    return false;
  };

  const showToast = (message: ToastContent, options: ToastOptions = {}) => {
    let toastOptions: ToastOptions = {
      hideProgressBar: true,
      type: 'default',
      position: 'top-center',
      autoClose: TOAST_AUTO_CLOSE_MS.DEFAULT,
      theme: 'dark',
      icon: false,
    };
    toastOptions = { ...toastOptions, ...options };
    toastOptions.icon = getToastIcon(toastOptions.type);
    toast(message, toastOptions);
  };

  return { showToast };
};
